__turbopack_context__.v({
  "borderLeft": "WAb_uq_borderLeft",
  "borderRight": "WAb_uq_borderRight",
  "borderRightBottom": "WAb_uq_borderRightBottom",
  "box1": "WAb_uq_box1",
  "box2": "WAb_uq_box2",
  "cards": "WAb_uq_cards",
  "circleImage": "WAb_uq_circleImage",
  "container1": "WAb_uq_container1",
  "container2": "WAb_uq_container2",
  "container3": "WAb_uq_container3",
  "container4": "WAb_uq_container4",
  "content": "WAb_uq_content",
  "contentjourney": "WAb_uq_contentjourney",
  "headContact": "WAb_uq_headContact",
  "headjourney": "WAb_uq_headjourney",
  "imageJourney3": "WAb_uq_imageJourney3",
  "imgJourney1": "WAb_uq_imgJourney1",
  "imgJourney2": "WAb_uq_imgJourney2",
  "imgs": "WAb_uq_imgs",
  "j1": "WAb_uq_j1",
  "journey2": "WAb_uq_journey2",
  "journey3": "WAb_uq_journey3",
  "netralcolor": "WAb_uq_netralcolor",
  "p": "WAb_uq_p",
  "page-body-wrap": "WAb_uq_page-body-wrap",
  "paragraph": "WAb_uq_paragraph",
  "paragraph-content": "WAb_uq_paragraph-content",
  "paragraphJourney": "WAb_uq_paragraphJourney",
  "paragraphJourney3": "WAb_uq_paragraphJourney3",
  "pointJourney": "WAb_uq_pointJourney",
  "pointParagraphJourney": "WAb_uq_pointParagraphJourney",
  "t": "WAb_uq_t",
  "title": "WAb_uq_title",
  "titleJourney": "WAb_uq_titleJourney",
  "titleJourney2": "WAb_uq_titleJourney2",
  "titleJourney3": "WAb_uq_titleJourney3",
  "wrap-container": "WAb_uq_wrap-container",
  "wrap-content": "WAb_uq_wrap-content",
});
